import { EditPassword } from "./page"

export default EditPassword